(function () {
  function getText(root, selector) {
    var node = root.querySelector(selector);
    return node ? node.textContent.trim() : '';
  }

  function initSection(section) {
    if (!section || section.dataset.creatorPageReady === 'true') return;
    section.dataset.creatorPageReady = 'true';

    var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-creator-filter]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-creator-card]'));
    var triggers = Array.prototype.slice.call(section.querySelectorAll('[data-creator-open]'));
    var viewMoreButton = section.querySelector('[data-creator-view-more]');
    var modal = section.querySelector('[data-creator-modal]');
    var batchSize = 20;
    var visibleCount = batchSize;
    var activeCategory = 'all';

    function getMatchingCards() {
      return cards.filter(function (card) {
        var cardCategory = card.dataset.creatorCategory || '';
        return activeCategory === 'all' || cardCategory === activeCategory;
      });
    }

    function applyCardVisibility() {
      var matchingCards = getMatchingCards();
      cards.forEach(function (card) {
        var matchesCategory = matchingCards.indexOf(card) !== -1;
        var visibleIndex = matchingCards.indexOf(card);
        card.classList.toggle('is-hidden', !matchesCategory || visibleIndex >= visibleCount);
      });

      if (viewMoreButton) {
        viewMoreButton.hidden = matchingCards.length <= visibleCount;
      }
    }

    applyCardVisibility();

    if (filterButtons.length) {
      filterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeCategory = button.dataset.creatorFilter || 'all';
          visibleCount = batchSize;
          filterButtons.forEach(function (item) {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });

          applyCardVisibility();
        });
      });
    }

    if (viewMoreButton) {
      viewMoreButton.addEventListener('click', function () {
        visibleCount += batchSize;
        applyCardVisibility();
      });
    }

    if (!triggers.length || !modal) return;

    var media = modal.querySelector('[data-creator-media]');
    var closeButtons = modal.querySelectorAll('[data-creator-close]');
    var prevButton = modal.querySelector('[data-creator-prev]');
    var nextButton = modal.querySelector('[data-creator-next]');
    var soundButton = modal.querySelector('[data-creator-sound]');
    var soundOff = modal.querySelector('[data-creator-sound-off]');
    var soundOn = modal.querySelector('[data-creator-sound-on]');
    var productCard = modal.querySelector('[data-creator-product]');
    var activeIndex = 0;
    var muted = true;
    var touchStartX = 0;
    var touchStartY = 0;
    var activeVideo = null;

    function getProduct(trigger) {
      var source = trigger.closest('[data-creator-card]').querySelector('[data-creator-product-data]');
      if (!source) return null;

      var product = {
        title: getText(source, '[data-creator-product-title]'),
        url: getText(source, '[data-creator-product-url]'),
        price: getText(source, '[data-creator-product-price]'),
        compare: getText(source, '[data-creator-product-compare]'),
        image: getText(source, '[data-creator-product-image]')
      };

      if (!product.title || !product.url || !product.price) return null;
      return product;
    }

    function clearMedia() {
      if (!media) return;
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.removeAttribute('src');
        activeVideo.querySelectorAll('source').forEach(function (source) {
          source.removeAttribute('src');
          source.removeAttribute('type');
          source.remove();
        });
        activeVideo.load();
        activeVideo.remove();
        activeVideo = null;
      }
      media.textContent = '';
    }

    function isDirectVideoUrl(url) {
      return /\.(mp4|m4v|mov|webm)(\?.*)?$/i.test(url || '');
    }

    function normalizeSourceType(url, type) {
      if (type && type.indexOf('/') > -1) return type;
      if (/\.webm(\?.*)?$/i.test(url)) return 'video/webm';
      if (/\.(mp4|m4v|mov)(\?.*)?$/i.test(url)) return 'video/mp4';
      return type || '';
    }

    function canPlaySource(video, source) {
      if (!source.type) return true;
      return video.canPlayType(source.type) !== '';
    }

    function chooseBestSource(trigger, video) {
      var card = trigger.closest('[data-creator-card]');
      var sourceNodes = Array.prototype.slice.call(card.querySelectorAll('[data-creator-source]'));
      var shopifySources = sourceNodes
        .map(function (node) {
          var url = node.dataset.creatorSourceUrl || '';
          return {
            url: url,
            type: normalizeSourceType(url, node.dataset.creatorSourceType || ''),
            height: parseInt(node.dataset.creatorSourceHeight || '0', 10) || 0
          };
        })
        .filter(function (source) {
          return source.url && canPlaySource(video, source);
        });

      if (shopifySources.length) {
        var mp4Sources = shopifySources.filter(function (source) {
          return source.type === 'video/mp4' || /\.mp4(\?.*)?$/i.test(source.url);
        });
        var candidates = mp4Sources.length ? mp4Sources : shopifySources;
        var under1080 = candidates.filter(function (source) {
          return source.height > 0 && source.height <= 1080;
        });

        if (under1080.length) {
          under1080.sort(function (a, b) {
            return b.height - a.height;
          });
          return under1080[0];
        }

        candidates.sort(function (a, b) {
          return a.height - b.height;
        });
        return candidates[0];
      }

      var externalUrl = trigger.dataset.creatorExternalVideoUrl || '';
      if (!externalUrl) return null;
      if (!isDirectVideoUrl(externalUrl)) {
        console.warn('[Creator page] External MP4 URL is not a direct supported video file:', externalUrl);
        return null;
      }

      var externalSource = {
        url: externalUrl,
        type: normalizeSourceType(externalUrl, ''),
        height: 0
      };
      return canPlaySource(video, externalSource) ? externalSource : null;
    }

    function renderPoster(poster) {
      if (!media || !poster) return null;
      var image = document.createElement('img');
      image.className = 'creator-page-modal__poster';
      image.src = poster;
      image.alt = '';
      media.appendChild(image);
      return image;
    }

    function renderUnavailable() {
      if (!media) return;
      var message = document.createElement('span');
      message.className = 'creator-page-modal__error';
      message.textContent = 'Video unavailable';
      media.appendChild(message);
    }

    function renderProduct(trigger) {
      if (!productCard) return;
      var product = getProduct(trigger);
      if (!product) {
        productCard.hidden = true;
        productCard.removeAttribute('href');
        return;
      }

      productCard.hidden = false;
      productCard.href = product.url;
      var image = productCard.querySelector('[data-creator-product-image-target]');
      var title = productCard.querySelector('[data-creator-product-title-target]');
      var price = productCard.querySelector('[data-creator-product-price-target]');
      var compare = productCard.querySelector('[data-creator-product-compare-target]');

      if (image) {
        image.src = product.image || '';
        image.hidden = !product.image;
      }
      if (title) title.textContent = product.title;
      if (price) price.textContent = product.price;
      if (compare) {
        compare.textContent = product.compare;
        compare.hidden = !product.compare;
      }
    }

    function renderMedia(trigger) {
      clearMedia();
      var poster = trigger.dataset.creatorPoster || '';
      var posterImage = renderPoster(poster);
      var video = document.createElement('video');
      var source = chooseBestSource(trigger, video);

      if (!source) {
        console.error('[Creator page] No playable Shopify video source or valid external video URL was found.');
        renderUnavailable();
        return;
      }

      video.className = 'creator-page-modal__video';
      video.playsInline = true;
      video.muted = muted;
      video.loop = true;
      video.preload = 'metadata';
      video.controls = false;
      if (poster) video.poster = poster;

      var sourceNode = document.createElement('source');
      sourceNode.src = source.url;
      if (source.type) sourceNode.type = source.type;
      video.appendChild(sourceNode);

      video.addEventListener('canplay', function () {
        video.play().catch(function () {});
        video.classList.add('is-ready');
        if (posterImage) posterImage.classList.add('is-hidden');
      });

      video.addEventListener('error', function () {
        console.error('[Creator page] Video failed to load:', source.url);
        if (activeVideo === video) activeVideo = null;
        video.remove();
        renderUnavailable();
      });

      media.appendChild(video);
      activeVideo = video;
      video.load();
    }

    function syncSoundButton() {
      if (!soundButton) return;
      soundButton.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      if (soundOff) soundOff.hidden = !muted;
      if (soundOn) soundOn.hidden = muted;
      if (activeVideo) activeVideo.muted = muted;
    }

    function show(index, resetSound) {
      activeIndex = (index + triggers.length) % triggers.length;
      if (resetSound) muted = true;
      var trigger = triggers[activeIndex];
      renderMedia(trigger);
      renderProduct(trigger);
      syncSoundButton();
    }

    function open(index) {
      modal.hidden = false;
      document.documentElement.classList.add('creator-page-modal-open');
      show(index, true);
    }

    function close() {
      clearMedia();
      muted = true;
      modal.hidden = true;
      document.documentElement.classList.remove('creator-page-modal-open');
      syncSoundButton();
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        open(index);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(activeIndex - 1, false);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(activeIndex + 1, false);
      });
    }

    modal.addEventListener('click', function (event) {
      var navButton = event.target.closest('[data-creator-prev], [data-creator-next]');
      if (!navButton || !modal.contains(navButton)) return;
      event.preventDefault();
      event.stopPropagation();
      if (navButton.hasAttribute('data-creator-prev')) {
        show(activeIndex - 1, false);
      } else {
        show(activeIndex + 1, false);
      }
    });

    if (soundButton) {
      soundButton.addEventListener('click', function () {
        muted = !muted;
        syncSoundButton();
      });
    }

    modal.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    modal.addEventListener(
      'touchend',
      function (event) {
        if (!event.changedTouches || event.changedTouches.length !== 1 || modal.hidden) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaY) < 50 || Math.abs(deltaY) < Math.abs(deltaX)) return;

        if (deltaY < 0) {
          show(activeIndex + 1, false);
        } else {
          show(activeIndex - 1, false);
        }
      },
      { passive: true }
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    document.querySelectorAll('.creator-page').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('.creator-page'));
  });
})();
